import type { DiaCalendario, DiaComparecimentoStatus } from '../pages/relatorio-civel-page.models';

export type StatusComparecimentoLegenda = 'presente' | 'ausente' | 'remoto' | 'impedimento';

export type ContagensComparecimentoLegenda = Record<StatusComparecimentoLegenda, number>;

/** Conta quantas vezes cada status aparece no calendário do mês do relatório. */
export function contarStatusComparecimentoLegenda(
  calendario: (DiaCalendario | null)[][],
  getStatusDia: (dia: number, mes: string, ano: number) => DiaComparecimentoStatus | undefined,
  getImpedimentoDia: (dia: number, mes: string, ano: number) => unknown | null,
): ContagensComparecimentoLegenda {
  const counts: ContagensComparecimentoLegenda = {
    presente: 0,
    ausente: 0,
    remoto: 0,
    impedimento: 0,
  };

  for (const semana of calendario) {
    for (const dia of semana) {
      if (!dia?.isMesAtual) continue;

      const impedimento = getImpedimentoDia(dia.dia, dia.mes, dia.ano);
      if (impedimento) {
        counts.impedimento += 1;
        continue;
      }

      const status = getStatusDia(dia.dia, dia.mes, dia.ano)?.status;
      if (status === 'presente' || status === 'ausente' || status === 'remoto' || status === 'impedimento') {
        counts[status] += 1;
      }
    }
  }

  return counts;
}

/** Rótulo da legenda com contagem opcional (ex.: "Presente (2)"). */
export function rotuloLegendaComparecimento(label: string, count: number): string {
  if (count <= 0) return label;
  return `${label} (${count})`;
}
